import type { ReactNode } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Empty, Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { css } from "@linaria/core";

const icon = css`
  font-size: var(--ant-font-size-xl);
`;
const text = css`
  font-size: var(--ant-font-size-lg);
`;

type Props = {
  readonly loading: boolean;
  readonly emptyDescription: ReactNode;
  readonly emptyChildren?: ReactNode;
};

export const TableEmptyState = ({ loading, emptyDescription, emptyChildren = null }: Props) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Flex align="center" gap="small" justify="center">
        <SearchOutlined className={icon} />
        <Typography.Text className={text} type="secondary">
          {t("g.searching")}
        </Typography.Text>
      </Flex>
    );
  }

  return <Empty description={emptyDescription}>{emptyChildren}</Empty>;
};
